//@flow
import HeapStoreClass from './heapStoreClass';
import QuoteStore from '../Quote';
import CustomerStore from '../Customer/customer';
import ProductsStore from '../Products/products';
import MembershipStore from '../Membership/membershipStore';
import OrdersStore from '../Order/orderSingleton';
import SessionStore from '../Session/session';
import CategoriesStore from '../MemberCategories/categories';

const stores = {
  QuoteStore,
  CustomerStore,
  ProductsStore,
  MembershipStore,
  OrdersStore,
  SessionStore,
  CategoriesStore,
};

const HeapStore:HeapStoreClass = new HeapStoreClass(stores);
export default HeapStore;
